import { Children, useState } from 'react';
import { Button, Chip, Popover } from '@mui/material';
import clsx from 'clsx';

/**
 * PopList
 *
 * Componente para mostrar una lista de opciones en un popover, usando botón o chip como disparador.
 *
 * @component
 * @param {string} label - Texto del botón o chip
 * @param {boolean} [chip=false] - Si se usa un chip como disparador
 * @param {string} [listClasses] - Clases CSS adicionales para la lista
 * @param {React.ReactNode} children - Elementos a mostrar en la lista
 * @returns {JSX.Element}
 */
export const PopList = ({ label, chip = false, listClasses, children, ...props }) => {
  const childrenArray = Children.toArray(children);

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <div>
      {chip ? (
        <Chip label={label} {...props} size="small" aria-describedby={id} onClick={handleClick} />
      ) : (
        <Button {...props} size="small" aria-describedby={id} onClick={handleClick}>
          {label}
        </Button>
      )}
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <div className={clsx(listClasses, 'p-2')}>
          {childrenArray.map((child, key) => {
            return (
              <div key={`buttonForm_${key}`} className="px-16 py-4">
                {child}
              </div>
            );
          })}
        </div>
      </Popover>
    </div>
  );
};
